//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"RecipeCurves",0,"SelectNXObjectList",0],[0,"TrimType",1,0]],[[[],"CreateSection",{R_:{section:"Section"}},0,0],[["section"],"RemoveSection",{},1,0],[["num_sections"],"GetSections",{R_:{sections:"Section[]"}},0,0],[["help_point"],"SelectRegion",{},1,0],[["help_point"],"DeselectRegion",{},1,0],[[],"UpdateRegions",{},0,0],[[],"ResetRegions",{},0,0]],[]];
SPLM.SketchAssociativeTrimBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchAssociativeTrimBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchAssociativeTrimBuilder.TrimOption = Object.freeze({
    "Keep" : "Keep", "Discard" : "Discard"});

export default SPLM;